import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link, match } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ModifyProfilForm from '../../components/templates/form-modify-profil';
import CreateProfilForm from '../../components/templates/form-create-profil';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import {
  ProfilActions,
  ProfilSelectors,
  SectionsActions,
  SectionsSelectors,
  ProfilesSelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import history from '../../app-router/history';
import Card from '../../components/molecules/card';
import { ProfilParams } from 'types';

const Wrapper = styled.div`
  margin: 5px;
`;

const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}
const Profil: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const { id } = props.match.params;

  const sections = useSelector(SectionsSelectors.sectionsSelector);
  const profils = useSelector(ProfilesSelectors.profilesSelector);
  const profil = id ? profils?.find((hi) => hi.id.toString() === id) : undefined;

  const error = useSelector(ProfilSelectors.errorSelector);
  const status = useSelector(ProfilSelectors.statusSelector);

  useEffect(() => {
    dispatch(SectionsActions.fetchSections());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Profil', sliceKey: 'error' }));
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Profil', sliceKey: 'status' }));
    };
  }, [dispatch]);

  const onCreateHandler = (values: Omit<ProfilParams, 'id'>) => {
    dispatch(
      ProfilActions.createProfil(values, (result) => {
        if (!result.cancelled && !result.error) {
          history.push('/profils');
        }
      })
    );
  };
  const onUpdateHandler = (values: ProfilParams) => {
    dispatch(
      ProfilActions.updateProfil(values, (result) => {
        if (!result.cancelled && !result.error) {
          history.push('/profils');
        }
      })
    );
  };
  const title = id ? t('ProfilPage', 'PROFIL_UPDATE') : t('ProfilPage', 'PROFIL_CREATE');
  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link to="/profils">{t('ProfilPage', 'PROFIL_BACK')}</Link>
        </StyledBreadcrumbWrapper>
        <Card title={title}>
          {id ? (
            <ModifyProfilForm
              id={id}
              onUpdate={onUpdateHandler}
              sections={sections}
              profil={profil}
              error={error}
              status={status}
            />
          ) : (
            <CreateProfilForm sections={sections} onCreate={onCreateHandler} error={error} status={status} />
          )}
        </Card>
      </Wrapper>
    </div>
  );
};

export default Profil;
